<mat-horizontal-stepper [selectedIndex]="stepIndex" class="wizard-background" linear="true" #stepper>
  <mat-step [completed]="reservationPatientCompleted">
      <div>
          <div class="card-container">
              <ng-template matStepLabel>Seleccione al paciente</ng-template>
              <app-reservation-patient-component #reservationPatientComponent></app-reservation-patient-component>
          </div>
      </div>
  </mat-step>
  <mat-step [completed]="reservationPracticeCompleted">
      <div class="card-container">
          <ng-template matStepLabel>Cargue las prácticas</ng-template>
          <app-reservation-practice-component #reservationPracticeComponent></app-reservation-practice-component>
      </div>
  </mat-step>
  <mat-step [completed]="reservationQuestionCompleted">
      <div class="card-container">
          <ng-template matStepLabel>Condiciones</ng-template>
          <app-reservation-question-component #reservationQuestionComponent></app-reservation-question-component>
      </div>
  </mat-step>
  <mat-step [completed]="reservationCalendarCompleted">
      <div class="card-container">
          <ng-template matStepLabel>Turno</ng-template>
          <app-reservation-extraordinary-calendar [showAppointmeDate]="true" #reservationCalendarComponent></app-reservation-extraordinary-calendar>
      </div>
  </mat-step>
</mat-horizontal-stepper>
